import { EntReservoirHistoryFilter } from "../../../models/filters/reservoirHistoryFilter";
import { EntReservoirGroupByHistory } from "../../../models/reservoirGroupByHistory";
import { EntReservoirHistory } from "../../../models/reservoirHistory";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import dayjs from "dayjs";
import { EntReportReservoirHistory } from "../../../models/utils/reportReservoirHistory";
import { Paths } from "../../../paths";

export const reservoirHistoryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getReservoirHistoryList: builder.query<ResponseDataGet<EntReservoirHistory>, EntReservoirHistoryFilter>({
      query: (filter) => ({
        url: `${Paths.reservoirshistory}/get-all`,
        method: "POST",
        body: JSON.stringify(filter, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return dayjs(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    getReservoirHistoryGroupByList: builder.query<ResponseDataGet<EntReservoirGroupByHistory>, EntReservoirHistoryFilter>({
      query: (filter) => ({
        url: `${Paths.reservoirshistory}/analytical-data`,
        method: "POST",
        body: JSON.stringify(filter, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return dayjs(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    getReservoirHistoryById: builder.query<ResponseDataTest<EntReservoirHistory>, number>({
      query: (id) => ({
        url: `${Paths.reservoirshistory}/${id}`,
        method: 'GET'
      })
    }),

    addReservoirHistoryList: builder.mutation<ResponseDataTest<EntReservoirGroupByHistory>, EntReservoirGroupByHistory>({
      query: (body) => ({
        url: `${Paths.reservoirshistory}/list`,
        method: "POST",
        body: JSON.stringify(body, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return dayjs(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    editReservoirHistory: builder.mutation<ResponseDataTest<EntReservoirGroupByHistory>, EntReservoirGroupByHistory>({
      query: (body,) => ({
        url: `${Paths.reservoirshistory}/list`,
        method: 'PUT',
        body: JSON.stringify(body, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return dayjs(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    deleteReservoirHistory: builder.mutation<ResponseDataTest<EntReservoirGroupByHistory>, number>({
      query: (id) => ({
        url: `${Paths.reservoirshistory}/${id}`,
        method: 'DELETE',
      }),
    }),
    generateReportReservoirHistory: builder.mutation<any, EntReportReservoirHistory>({
      query: (body) => ({
        url: '/report/all-reservoirs-history-by-days',
        method: 'POST',
        body: JSON.stringify(body, (key, value) =>{
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return dayjs(value).format('YYYY-MM-DD');
          }
          return value;
        }),
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useDeleteReservoirHistoryMutation,
  useEditReservoirHistoryMutation,
  useGenerateReportReservoirHistoryMutation,
  useAddReservoirHistoryListMutation,
  useLazyGetReservoirHistoryGroupByListQuery
} = reservoirHistoryApi;
